(function () {
  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function scoreTerm(queryNorm, textNorm) {
    if (!queryNorm) return 1;
    if (!textNorm) return 0;
    if (textNorm === queryNorm) return 100;
    if (textNorm.startsWith(queryNorm)) return 88;
    if (textNorm.includes(queryNorm)) return 72;
    const words = queryNorm.split(' ').filter(function (w) {
      return w.length > 1;
    });
    if (!words.length) {
      return textNorm.includes(queryNorm) ? 55 : 0;
    }
    var s = 0;
    for (var i = 0; i < words.length; i++) {
      if (textNorm.includes(words[i])) s += 22;
    }
    return s;
  }

  function combinedScore(queryNorm, titleNorm, addressNorm) {
    if (!queryNorm) return 1;
    var t = scoreTerm(queryNorm, titleNorm);
    var a = scoreTerm(queryNorm, addressNorm) * 0.82;
    return Math.max(t, a);
  }

  function init(root) {
    var input = root.querySelector('[data-locations-search-input]');
    var form = root.querySelector('form.locations-search__form');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-locations-item]'));
    var emptyMsg = root.querySelector('[data-locations-search-empty]');
    if (!input || !items.length) return;

    function run() {
      var q = normalize(input.value);
      if (!q) {
        items.forEach(function (el) {
          el.style.removeProperty('display');
          el.style.removeProperty('order');
        });
        if (emptyMsg) emptyMsg.hidden = true;
        return;
      }

      var scored = items.map(function (el) {
        var title = normalize(el.getAttribute('data-search-title') || '');
        var addr = normalize(el.getAttribute('data-search-address') || '');
        return {
          el: el,
          score: combinedScore(q, title, addr),
        };
      });

      var matches = scored
        .filter(function (x) {
          return x.score > 0;
        })
        .sort(function (a, b) {
          return b.score - a.score;
        });

      var ord = 0;
      matches.forEach(function (x) {
        x.el.style.display = '';
        x.el.style.order = String(ord++);
      });

      scored
        .filter(function (x) {
          return x.score <= 0;
        })
        .forEach(function (x) {
          x.el.style.display = 'none';
          x.el.style.removeProperty('order');
        });

      if (emptyMsg) emptyMsg.hidden = matches.length > 0;
    }

    input.addEventListener('input', run);
    input.addEventListener('search', run);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        run();
        input.focus();
      });
    }
  }

  function boot() {
    document.querySelectorAll('.js-locations-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
